export enum ResetPasswordConstants {
  Title = 'Reset your password',
  Subtitle = 'Enter the email address associated with your account to begin the password reset process.',
  EmailAddress = 'Email address',
  CTA = 'Reset password',
  Placeholder = 'you@domain.com',
  EmailError = 'Please input a valid email address',
  RequiredError = 'Enter your email address',
}
